(function ($) {
	// On Dom Ready
	$(function () {
		/* $('select').on('selectric-init', function(element){
			$(this).closest('.selectric-wrapper').find('.selectric-input').attr('type', 'hidden');
		}); */

		$("select").selectric({
			arrowButtonMarkup: '<span class="arrow"></span>',
			disableOnMobile: false,
			nativeOnMobile: false,
		});
		$("input.selectric-input").attr("readonly", true);
	});


})(jQuery);
